module.exports = __webpack_public_path__ + "static/media/tianguis.05aece75.svg";